module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ;  var provider = widget.item; 
    ; __append("\n<div class=\"spl-WebServices-page\">\n    <div class=\"table\">\n        <div class=\"section\">\n            <div class=\"title\">Имя</div>\n            <div>\n                <div\n                    data-control-type=\"text\"\n                    data-control-target=\"item.name\"\n                    >\n                    ")
    ; __append(escapeFn( provider.name ))
    ; __append("\n                </div>\n            </div>\n        </div>\n    </div>\n</div>")
  }
  return __output.join("");

}